import api from '../services/api';
import { asyncAction } from './actions';

export const fetchLockedJobs = (studentId) => asyncAction(
  'FETCH_LOCKED_JOBS',
  api.jobs.fetchLockedJobs(studentId),
);
